function SideBar() {
  return (
    <div className=" text-black px-5 max-w-[350px] w-full h-full top-0 sticky ">
      <Offers />
      <Custumers />
      <Share />
    </div>
  );
}

export default SideBar;

import { useRef } from "react";

// Import Swiper React components and required modules
import Image from "next/image";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import img1 from "@/assets/products/img1.png";
import Btn from "../uikit/Btn";
import Link from "next/link";
import { useRouter } from "next/router";
import productsData from "@/data/product";


function Offers() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <>
      <h2 className=" text-black font-bold text-xl capitalize mt-5 ">
        Our Latest Offers{" "}
      </h2>
      <div className="  my-3  relative ">
        <button
          ref={prevRef}
          aria-label="prev_button"
          className=" absolute -left-10 z-[10] top-[30%] hidden xl:flex  bg-black/5  items-center justify-center h-8 w-8 rounded-full "
        >
          <svg
            width="7"
            height="14"
            viewBox="0 0 9 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M8 15L1 8L8 1" stroke="black" />
          </svg>
        </button>
        <button
          ref={nextRef}
          aria-label="next_button"
          className=" absolute -right-10 z-[10] top-[30%] hidden xl:flex  bg-black/5  items-center justify-center h-8 w-8 rounded-full "
        >
          <svg
            width="7"
            height="14"
            viewBox="0 0 9 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L8 8L1 15" stroke="black" />
          </svg>
        </button>
        <Swiper
          modules={[Navigation, Autoplay]}
          slidesPerView={1}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
          className="flex justify-center  items-center"
        >
          {productsData.map((e, i) => (
            <SwiperSlide key={i} className="  ">
              <div className="  relative h-2/6 flex justify-center flex-col w-[95%] mx-auto  ">
                <div className=" bg-[#EC1C1C] text-xs px-3 py-0.5 absolute top-2 left-2 rounded-full text-white ">
                  Limited
                </div>
                <Image
                  src={e.img}
                  alt={e.altText}
                  width={500}
                  height={500}
                  quality={75}
                  priority
                  className="object-cover h-60 rounded-2xl border border-black/20 mx-auto  w-full   "
                />
                <div className=" flex justify-between items-center   ">
                  <div>
                    <div className=" flex mt-1 ">
                      {Array(5)
                        .fill(" ")
                        .map((e, i) => (
                          <svg
                            key={i}
                            width="15"
                            height="13"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z"
                              fill="#DE0404"
                            />
                          </svg>
                        ))}
                    </div>
                    <h2 className=" font-bold text-black text-sm max-w-[250px] text-balance ">{e.title}</h2>
                  </div>
                  <div className=" flex flex-col leading-none mt-3 ">
                    <p className=" text-black/20 line-through text-[10px] font-bold self-end ">
                      {e.comparedPrice}
                    </p>
                    <p className=" text-black font-bold ">{e.price}</p>
                  </div>
                </div>
                <Btn
                  text={"Claim Offer"}
                  link={'/product/' + e.slug}
                  className="border-[#EC1C1C] text-sm my-2 px-3 py-1.5 w-full mx-auto  bg-[#EC1C1C] text-[#fff] relative hover:shadow-none [box-shadow:#000_3px_3px]  inline-block rounded-xl border   text-center font-semibold   transition-all ease-in-out duration-300 hover:border-black  "
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
}

const Custumers = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <>
      <h2 className=" text-black font-bold text-xl capitalize mt-5 ">
        Our Loyal Customers
      </h2>

      <Swiper
        modules={[Navigation, Autoplay]}
        slidesPerView={1}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        className="flex justify-center mt-3 items-center"
      >
        {customersData.map((e, i) => (
          <SwiperSlide key={i} className="   ">
            <div className=" border border-black/20 rounded-2xl p-3 relative h-2/6 flex justify-center flex-col xl:w-[95%] mx-auto  ">
              <div className=" flex justify-between items-start ">
                <div className=" flex gap-2 ">
                  <Image
                    src={e.picture}
                    alt={`Slider image ${i}`}
                    width={500}
                    height={500}
                    quality={75}
                    priority
                    className="object-cover h-10  w-10  rounded-full  "
                  />
                  <div className=" ">
                    <h3 className=" text-black font-bold ">{e.name}</h3>
                    <p className=" text-[#000000]/20 text-xs -mt-1 ">
                      {e.status}
                    </p>
                  </div>
                </div>
                <div className=" flex mt-1 ">
                  {Array(5)
                    .fill(" ")
                    .map((e, i) => (
                      <svg
                        key={i}
                        width="9"
                        height="8"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.3 0L5.26541 2.97123H8.38954L5.86207 4.80755L6.82748 7.77877L4.3 5.94245L1.77252 7.77877L2.73793 4.80755L0.210457 2.97123H3.33459L4.3 0Z"
                          fill="#C8CB0F"
                        />
                      </svg>
                    ))}
                </div>
              </div>

              <p className=" text-black text-xs mt-2 ">{e.testimonial}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className=" flex space-x-4 mt-2  mx-auto justify-between  sm:justify-between  ">
        <div className=" flex space-x-2 items-end ">
          <button
            ref={prevRef}
            aria-label="prev_button"
            className=" bg-black/5 flex items-center justify-center h-8 w-8 rounded-full "
          >
            <svg
              width="7"
              height="14"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8 15L1 8L8 1" stroke="black" />
            </svg>
          </button>
          <button
            ref={nextRef}
            aria-label="next_button"
            className="   bg-black/5 flex items-center justify-center h-8 w-8 rounded-full "
          >
            <svg
              width="7"
              height="14"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L8 8L1 15" stroke="black" />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

const Share = () => {
  const router = useRouter()
  return (
    <div className=" flex  items-center justify-between ">
      <h2 className=" text-black font-bold text-xl capitalize mt-5 ">Share </h2>
      <div className=" flex gap-x-2 mt-5 items-center justify-center ">
        <Link aria-label="share_on_facebook" href={`https://www.facebook.com/share.php?u=https://yourcad.store${router.asPath}`} target="_blank" id="facebook" className=" w-7 h-7 my-auto ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 24 24"
          >
            <path d="M12,2C6.477,2,2,6.477,2,12c0,5.013,3.693,9.153,8.505,9.876V14.65H8.031v-2.629h2.474v-1.749 c0-2.896,1.411-4.167,3.818-4.167c1.153,0,1.762,0.085,2.051,0.124v2.294h-1.642c-1.022,0-1.379,0.969-1.379,2.061v1.437h2.995 l-0.406,2.629h-2.588v7.247C18.235,21.236,22,17.062,22,12C22,6.477,17.523,2,12,2z"></path>
          </svg>
        </Link>
        <Link aria-label="share_on_twitter" href={`https://twitter.com/intent/tweet?url=https://yourcad.store${router.asPath}`}  target="_blank" id="twitter" className=" w-7 h-7 my-auto ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 24 24"
          >
            <path d="M22,3.999c-0.78,0.463-2.345,1.094-3.265,1.276c-0.027,0.007-0.049,0.016-0.075,0.023c-0.813-0.802-1.927-1.299-3.16-1.299 c-2.485,0-4.5,2.015-4.5,4.5c0,0.131-0.011,0.372,0,0.5c-3.353,0-5.905-1.756-7.735-4c-0.199,0.5-0.286,1.29-0.286,2.032 c0,1.401,1.095,2.777,2.8,3.63c-0.314,0.081-0.66,0.139-1.02,0.139c-0.581,0-1.196-0.153-1.759-0.617c0,0.017,0,0.033,0,0.051 c0,1.958,2.078,3.291,3.926,3.662c-0.375,0.221-1.131,0.243-1.5,0.243c-0.26,0-1.18-0.119-1.426-0.165 c0.514,1.605,2.368,2.507,4.135,2.539c-1.382,1.084-2.341,1.486-5.171,1.486H2C3.788,19.145,6.065,20,8.347,20 C15.777,20,20,14.337,20,8.999c0-0.086-0.002-0.266-0.005-0.447C19.995,8.534,20,8.517,20,8.499c0-0.027-0.008-0.053-0.008-0.08 c-0.003-0.136-0.006-0.263-0.009-0.329c0.79-0.57,1.475-1.281,2.017-2.091c-0.725,0.322-1.503,0.538-2.32,0.636 C20.514,6.135,21.699,4.943,22,3.999z"></path>
          </svg>
        </Link>
        {/* <button id="instagram" className=" w-7 h-7 my-auto ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 24 24"
          >
            <path d="M 8 3 C 5.239 3 3 5.239 3 8 L 3 16 C 3 18.761 5.239 21 8 21 L 16 21 C 18.761 21 21 18.761 21 16 L 21 8 C 21 5.239 18.761 3 16 3 L 8 3 z M 18 5 C 18.552 5 19 5.448 19 6 C 19 6.552 18.552 7 18 7 C 17.448 7 17 6.552 17 6 C 17 5.448 17.448 5 18 5 z M 12 7 C 14.761 7 17 9.239 17 12 C 17 14.761 14.761 17 12 17 C 9.239 17 7 14.761 7 12 C 7 9.239 9.239 7 12 7 z M 12 9 A 3 3 0 0 0 9 12 A 3 3 0 0 0 12 15 A 3 3 0 0 0 15 12 A 3 3 0 0 0 12 9 z"></path>
          </svg>
        </button> */}
      </div>
    </div>
  );
};

const data = [
  {
    text: "“L'huile de pépins de figue de barbarie est aujourd'hui vendu comme un élixir de jouvence ”",
  },
  {
    text: "“ Huile de figue de Barbarie : le soin anti-âge naturel aux bienfaits précieux ”",
  },
  {
    text: "“ L’huile de figue de barbarie, le secret anti-âge ”",
  },
  {
    text: "“ L'huile de figue de barbarie : l'atout anti-âge et beauté des cheveux ”",
  },
];

const customersData = [
  {
    name: "Michael Chen",
    picture: "/profiles/img1.png",
    rate: 5,
    testimonial: `"Being in the field of civil engineering, precision and innovation are non-negotiable. Youcad's budget-friendly Autodesk solutions have proven to be my go-to. It's like having a customized tool for every project, and the cost-effectiveness is a huge bonus."`,
    status: "Civil Engineer",
  },
  {
    name: "Michael Chen",
    picture: "/profiles/img1.png",
    rate: 5,
    testimonial: `"Being in the field of civil engineering, precision and innovation are non-negotiable. Youcad's budget-friendly Autodesk solutions have proven to be my go-to. It's like having a customized tool for every project, and the cost-effectiveness is a huge bonus."`,
    status: "Civil Engineer",
  },
  {
    name: "Michael Chen",
    picture: "/profiles/img1.png",
    rate: 5,
    testimonial: `"Being in the field of civil engineering, precision and innovation are non-negotiable. Youcad's budget-friendly Autodesk solutions have proven to be my go-to. It's like having a customized tool for every project, and the cost-effectiveness is a huge bonus."`,
    status: "Civil Engineer",
  },
];
